import { render, staticRenderFns } from "./goodsLabels.vue?vue&type=template&id=173b3e6d&"
import script from "./goodsLabels.vue?vue&type=script&lang=js&"
export * from "./goodsLabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports